import { ModalProps } from '@vtex/admin-ui'
import { useEffect } from 'react'
import { Event } from 'typings'
import { useAnalytics } from 'use-analytics'
import { ConfirmationModal } from '../../../../ConfirmationModal'
import { messages } from '../messages'

type Props = {
  state: ModalProps['state']
  onConfirm: () => void
  onCancel: () => void
}

export function BudgetDeleteModal(props: Props) {
  const { state, onConfirm, onCancel } = props

  const { track } = useAnalytics()

  const handleConfirm = () => {
    onConfirm()
    track(Event.BUDGET_MODAL_DELETE_CONFIRM_CLICK)
  }

  const handleCancel = () => {
    onCancel()
    track(Event.BUDGET_MODAL_DELETE_CANCEL_CLICK)
  }

  useEffect(() => {
    if (state.open) {
      track(Event.BUDGET_MODAL_DELETE_VIEW)
    }
  }, [state.open, track])

  return (
    <ConfirmationModal
      messages={messages.deleteModal}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      state={state}
      variant="critical"
    />
  )
}
